<template>
  <div>
    <header v-if="$store.getters.isAuthenticated" class="top-row">
      <div>
        <b-navbar toggleable="sm" type="dark" variant="info" class="bg-dark">
          <b-navbar-brand href="#" :class="online ? '' : 'text-danger'">
            <img src="static/img/logo.png" alt="Logo" style="width: 55px;height: 55px;margin: -10px 0 -10px -14px;">
            <b style="font-size: 12px;"> {{'v' + version}}</b>
            {{online ? ' Online' : ' Offline' }}
          </b-navbar-brand>
          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
              <b-nav-item
                :active="$route.name.indexOf('Local') > -1 || $route.name === 'ProtocolNew'"
                @click="$router.push({name: 'LocalProtocols'})"
              >
                {{ $trans.main.out_of_sync }}
              </b-nav-item>
              <b-nav-item
                :active="$route.name.indexOf('ApiProtocol') > -1 "
                @click="$router.push({name: 'ApiProtocols'})"
              >
                {{ $trans.main.protocols }}
              </b-nav-item>
              <b-nav-item
                v-if="is_user_admin"
                :active="$route.name.indexOf('Users') > -1 "
                @click="$router.push({name: 'Users'})"
              >
                {{ $trans.users }}
              </b-nav-item>
              <b-nav-item
                v-if="is_user_admin"
                @click="logout()"
              >
                {{ $trans.main.button_logout }}
              </b-nav-item>
            </b-navbar-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <b-nav-form>
                <b-button v-if="!['ProtocolNew', 'LocalProtocolEdit', 'ApiProtocolEdit'].includes($route.name)"
                          size="sm"
                          class="my-2 my-sm-0 btn-success"
                          @click="$router.push({name: 'ProtocolNew'})"
                >
                  {{ $trans.main.button_add }}
                </b-button>
              </b-nav-form>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </header>
    <main role="main" class="py-5 mb-5">
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </main>
    <footer>
    </footer>
  </div>

</template>

<script>
import {AUTH_LOGOUT, USER_SUCCESS} from './store/actions'
import {mapActions} from 'vuex'

export default {
  name: 'App',
  mounted: function () {
    if (this.$store.getters.isAuthenticated) {
      this.$store.commit(USER_SUCCESS, JSON.parse(localStorage.getItem('user')))
      this.is_user_admin = this.$store.getters.hasRole('admin')
    }
  },
  data () {
    return {
      online: navigator.onLine,
      is_user_admin: true,
      auth: this.$store.getters.isAuthenticated,
      version: '2.5'
    }
  },
  methods: {
    ...mapActions([AUTH_LOGOUT]),
    async logout () {
      await this.AUTH_LOGOUT()
      await this.$router.push({name: 'Login'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue